<aside class="col-xs-12 col-sm-12 col-md-12 children-vaccines-aside">
    <div class="row">
      <div class="col-md-12">
          <ul class="acc-banner">
              <li>
                  <div class="square-banner" *ngIf="imgUrl1">
                      <!-- <img src="../../../assets/img/Square-Marketing-Banner.png" class="img-fluid" alt="banner1"> -->
                      <img [src]="imgUrl1" class="img-fluid" alt="banner1"> 
                    </div>
              </li>
              <li>
                  <div class="vertical-banner" *ngIf="imgUrl2">
                      <!-- <img src="../../../assets/img/Vertical-Marketing-Banner.png" class="img-fluid" alt="banner2"> -->
                      <img [src]="imgUrl2" class="img-fluid" alt="banner2">
                    </div>
              </li>
          </ul>
      </div>
    </div>  
</aside>